const customerSelector = {
  isCustomerLoggedIn: state => state.customerReducer.isCustomerLoggedIn,
  isGuestFlow: state => state.customerReducer.isGuestFlow,
  customerInfo: state => state.customerReducer.customerInfo,
  isCustomerBeingRegistered : state => state.customerReducer.isCustomerBeingRegistered,
  isCustomerBeingLoggedIn : state => state.customerReducer.isCustomerBeingLoggedIn,
  customerOrders: state => state.customerReducer.customerOrders,
  isCustomerOrdersBeingFetched : state => state.customerReducer.isCustomerOrdersBeingFetched,
  isPasswordBeingUpdated : state => state.customerReducer.isPasswordBeingUpdated,

  isOtpBeingSent : state => state.customerReducer.isOtpBeingSent,
  isOtpSent : state => state.customerReducer.isOtpSent,
  isOtpBeingVerified : state => state.customerReducer.isOtpBeingVerified,
  isOtpVerified: state => state.customerReducer.isOtpVerified,
  otpErrorMessage: state => state.customerReducer.otpErrorMessage,

  isAddressBeingAdded : state => state.customerReducer.isAddressBeingAdded,
  isAddressBeingRemoved : state => state.customerReducer.isAddressBeingRemoved,
  isAddressBeingUpdated : state => state.customerReducer.isAddressBeingUpdated,
  isCustomerInfoBeingUpdated: state => state.customerReducer.isCustomerInfoBeingUpdated

}

export default customerSelector
